<template>
  <div>
    <left-menu-admin menuActive="0"></left-menu-admin>
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row align="center" class="spacer" no-gutters>
                          <v-col cols="2" class='text-center'>
                            <v-img :src="form.logo" max-width="70px" v-if="form.logo !== ''"></v-img>
                            <v-avatar
                              v-else
                              color="brown"
                              size="70px"
                            >
                              <span class="white--text text-h5">NP</span>
                            </v-avatar>
                          </v-col>
                          <v-col cols="10" class='text-left'>
                            <b>{{nameOa}}</b>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
            </v-col>
            <v-col cols="12">
                <v-form ref="form_add" v-model="validAdd" lazy-validation>
                    <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row style="height: 80px">
                          <v-col cols="12" class='text-center'>
                            <v-text-field
                                label="ชื่อร้าน*"
                                v-model="form.name"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="height: 80px">
                          <v-col cols="12" class='text-center'>
                            <v-select
                              label="หมวดหมู่ร้าน*"
                              :items="optionsItemcategory"
                              dense
                              v-model="form.category"
                              :rules="[rules.required]"
                            ></v-select>
                            <!-- <v-text-field
                                label="หมวดหมู่ร้าน*"
                                v-model="form.category"
                                :rules="[rules.required]"
                                required
                            ></v-text-field> -->
                          </v-col>
                        </v-row>
                        <v-row style="height: 80px">
                          <v-col cols="12" class='text-center'>
                            <v-text-field
                                label="Admin User*"
                                v-model="form.userName"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="height: 80px">
                          <v-col cols="12" class='text-center'>
                            <v-text-field
                                label="Password*"
                                v-model="form.password"
                                :rules="[rules.required]"
                                required
                                :append-outer-icon="show ? 'mdi-eye-remove' : 'mdi-eye-check'"
                                :type="type"
                                @click:append-outer="showPass"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <!-- <v-row style="height: 120px">
                          <v-col cols="12" class='text-center'>
                            <v-text-field
                                label="Confirm Password*"
                                v-model="form.confirmPassword"
                                :rules="[rules.required]"
                                :append-outer-icon="showConfirm ? 'mdi-eye-remove' : 'mdi-eye-check'"
                                :type="typeConfirm"
                                @click:append-outer="showPassConfirm"
                                required
                            ></v-text-field>
                          </v-col>
                        </v-row> -->
                        <br>
                        <div class="text-right">
                            <v-btn
                                elevation="2"
                                color="success"
                                :disabled="!validAdd"
                                @click="addData()"
                                >
                                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                สร้างร้าน
                            </v-btn>
                        </div>
                      </v-container>
                    </v-card-text>
                    </v-card>
                  </v-form>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
  </div>
</template>
<script>
import adminLeftMenu from '../SidebarManageShop.vue' // เมนู
import moment from 'moment-timezone'
import axios from 'axios' // api
export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      validAdd: true,
      show: '',
      nameOa: '',
      showConfirm: '',
      returnLink: '/system/ManageShop',
      type: 'password',
      typeConfirm: 'password',
      optionsItemcategory: [
        { text: 'ผู้เชี่ยวชาญ', value: 'ผู้เชี่ยวชาญ' },
        { text: 'ร้านอาหารและเครื่องดื่ม', value: 'ร้านอาหารและเครื่องดื่ม' },
        { text: 'ยานพาหนะ', value: 'ยานพาหนะ' },
        { text: 'อสังหาริมทรัพย์', value: 'อสังหาริมทรัพย์' },
        { text: 'การศึกษา', value: 'การศึกษา' },
        { text: 'การท่องเที่ยว', value: 'การท่องเที่ยว' },
        { text: 'ธุรกิจบันเทิง', value: 'ธุรกิจบันเทิง' },
        { text: 'สุขภาพ', value: 'สุขภาพ' },
        { text: 'ความงาม', value: 'ความงาม' },
        { text: 'องค์กร หรือสถาบัน', value: 'องค์กร หรือสถาบัน' },
        { text: 'หน่วยงานราชการ', value: 'หน่วยงานราชการ' },
        { text: 'ธุรกิจบริการ', value: 'ธุรกิจบริการ' },
        { text: 'ค้าขาย, ร้านค้า', value: 'ค้าขาย, ร้านค้า' },
        { text: 'ธุรกิจในพื้นที่ประเภทอื่น', value: 'ธุรกิจในพื้นที่ประเภทอื่น' },
        { text: 'องค์กรธุรกิจ, กลุ่มองค์กร', value: 'องค์กรธุรกิจ, กลุ่มองค์กร' },
        { text: 'แบรนด์, ผลิตภัณฑ์', value: 'แบรนด์, ผลิตภัณฑ์' },
        { text: 'หนังสือ,นิตยสาร,หนังสือพิมพ์', value: 'หนังสือ,นิตยสาร,หนังสือพิมพ์' },
        { text: 'ภาพยนตร์', value: 'ภาพยนตร์' },
        { text: 'ดนตรี', value: 'ดนตรี' },
        { text: 'กีฬา', value: 'กีฬา' },
        { text: 'โทรทัศน์', value: 'โทรทัศน์' },
        { text: 'เว็บไซต์&amp;บล็อก', value: 'เว็บไซต์&amp;บล็อก' }
      ],
      form: {
        userCode: '',
        displayName: '',
        logo: '',
        name: '',
        category: '',
        userName: '',
        password: '',
        productName: '',
        // confirmPassword: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        userCreate: '',
        flexPicHomePage: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Screen%20Shot%202565-04-25%20at%2010.11.03.png?alt=media&token=550c3714-fa10-4ea8-b46d-527e7c5d4792',
        flexPicMembercardPage: 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/Screen%20Shot%202565-04-25%20at%2010.11.58.png?alt=media&token=6695dd3b-9f4f-4d6f-a3e0-a0ebf5de105b'
      },
      rules: {
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        required: value => !!value || 'กรุณากรอก.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  // beforeCreate () {
  //   if (!this.$session.exists()) {
  //     this.$router.push('/Core/Login')
  //   }
  // },
  async mounted () {
    if (this.$route.query.state === 'register' && this.$route.query.productName === 'loyalty') {
      await this.getBotLineId()
      // await this.getOa()
      // await this.validate()
    } else {
      this.$swal('ผิดพลาด', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
    }
  },
  methods: {
    async getOaLink (shopIdDt) {
      console.log('shopIdDt', shopIdDt)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/getOa", {
            headers: {
              'botId': shopIdDt
            }
          }
        )
        .then(async (response) => {
          console.log('getOa', response.data)
          this.nameOa = response.data.displayName
          this.form.displayName = response.data.displayName
          if (response.data.pictureUrl) {
            this.form.logo = response.data.pictureUrl
          } else {
            this.form.logo = ''
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          // this.dataReady = true
        })
    },
    async getBotLineId () {
      let dt = {
        code: this.$route.query.code,
        redirect_uri: 'https://betask-loyalty-admin.web.app/System/ManageShop?productName=loyalty'
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/linkYourBot",
          dt
        )
        .then(async (response) => {
          console.log('getBotLineId', response.data)
          this.form.shopId = response.data.bot_id
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/system_shop/get?shopId=" + response.data.bot_id
            )
            .then(async (responses) => {
              if (responses.data.status !== false) {
                this.$swal('ผิดพลาด', 'ร้านค้าของท่านได้อยู่ในระบบแล้ว\nกรุณาล็อกอิน', 'error')
                this.$router.push('/Core/Login')
              } else {
                this.getOaLink(response.data.bot_id)
                this.validate()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log(error)
              this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
              this.dataReady = true
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    showPass () {
      if (this.type === 'password') {
        this.type = 'text'
        this.show = '1'
        console.log(this.type, this.show)
      } else {
        this.type = 'password'
        this.show = ''
        console.log(this.type, this.show)
      }
    },
    validate () {
      this.$nextTick(() => {
        let self = this
        self.$refs.form_add.validate()
      })
    },
    addData () {
      console.log('this.form', this.form)
      this.$swal({
        title: 'ตรวจสอบก่อนสร้างร้าน',
        text: 'ตรวจสอบข้อมูลของท่าน ท่านต้องการสร้างร้านหรือไม่',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#dedede',
        confirmButtonText: 'สร้างร้าน',
        cancelButtonText: 'ยกเลิก และตรวจสอบ!'
      })
        .then(async (result) => {
          await axios
            .get(
              // eslint-disable-next-line quotes
              this.DNS_IP +
            '/system_shop/get?userName=' +
            this.form.userName
            )
            .then(async (response) => {
              console.log('status', response.data.status)
              if (response.data.status === false) {
                this.form.CREATE_USER = 'System Create'
                this.form.LAST_USER = 'System Create'
                this.form.userCreate = 'System Create'
                this.form.userCode = 'SYS_USER_' + moment().valueOf()
                this.form.productName = this.$route.query.productName
                //   delete this.form['confirmPassword']   form.userName
                console.log('add', this.form)
                await axios
                  .post(
                  // eslint-disable-next-line quotes
                    this.DNS_IP + "/system_shop/createShop",
                    this.form
                  )
                  .then(async (response) => {
                    this.$swal('เรียบร้อย', 'สร้างร้าน เรียบร้อย', 'success')
                    this.$router.push('/Core/Login')
                  })
                // eslint-disable-next-line handle-callback-err
                  .catch((error) => {
                    console.log(error)
                    this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
                    this.dataReady = true
                  })
              } else {
                this.$swal('ผิดพลาด', 'ขออภัย Admin User นี้มีอยู่ในระบบอยู่แล้ว', 'error')
                this.form.userName = ''
              }
            })// eslint-disable-next-line handle-callback-err
            .catch(async (error) => {
              console.log(error)
              this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
              this.dataReady = true
            })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/ManageShop.vue